import { ApisauceInstance } from 'apisauce';

export interface BonusMetricDateField {
  metricId: string;
  dateField: string;
}

export interface BonusMetricAssignment {
  metricId: string;
  fieldName: string;
  dateField: string;
  datePeriodType: 'to_date' | 'full_period' | 'rolling';
  datePeriodLength: number;
  // Pulls the end of a to_date / rolling query window back by this many days
  // for late-landing data. Ignored for full_period.
  delayDays?: number;
  // Per-part date field overrides for a compound metric. GET returns every
  // part with its effective date field; [] for a simple metric.
  metricDateFields?: BonusMetricDateField[];
}

export interface BonusMetricsResponse {
  configFieldNames: string[];
  metrics: BonusMetricAssignment[];
}

const getBonusMetrics = ({
  api,
  driverBonusProgramId,
}: {
  api: ApisauceInstance;
  driverBonusProgramId: string;
}) => {
  return api.get<BonusMetricsResponse>(
    `/v1/driver_bonus/metrics?driver_bonus_program_id=${driverBonusProgramId}`,
  );
};

export default getBonusMetrics;
